import React, { useState } from "react";
import { Link } from "react-router-dom";
import AuthShell from "../components/AuthShell";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Button } from "../components/ui/button";
import { toast } from "sonner";
import { api, apiError } from "../lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim() });
      setSent(true);
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      side="client"
      title="Password dimenticata?"
      subtitle="Ti mandiamo una mail per reimpostarla. Controlla anche la cartella spam."
      altLinkLabel="← Torna al login"
      altLinkTo="/cliente/login"
      altLinkDataTestId="forgot-to-login"
    >
      {sent ? (
        <div
          data-testid="forgot-sent"
          className="space-y-4 rounded-2xl border border-[var(--mp-border)] bg-[var(--mp-dash-bg)] p-6"
        >
          <div className="font-display text-xl tracking-tight">Controlla la mail.</div>
          <p className="text-sm text-[var(--mp-muted)] leading-relaxed">
            Se l'indirizzo è registrato sul portale, riceverai entro pochi minuti un link
            per reimpostare la password. Il link è valido per 60 minuti. Se non lo vedi,
            controlla la cartella spam.
          </p>
          <div className="flex gap-2 flex-wrap">
            <Link
              to="/cliente/login"
              className="inline-flex items-center h-10 px-4 rounded-full border border-[var(--mp-ink)] text-sm font-semibold hover:bg-[var(--mp-ink)] hover:text-white transition-colors"
            >
              Vai al login
            </Link>
            <button
              type="button"
              onClick={() => setSent(false)}
              data-testid="forgot-retry"
              className="h-10 px-4 rounded-full text-sm font-semibold text-[var(--mp-muted)] hover:text-[var(--mp-ink)]"
            >
              Usa un'altra email
            </button>
          </div>
        </div>
      ) : (
        <form onSubmit={onSubmit} data-testid="forgot-form" className="space-y-5">
          <div>
            <Label
              htmlFor="email"
              className="text-xs font-bold uppercase tracking-[0.18em]"
            >
              Email
            </Label>
            <Input
              id="email"
              data-testid="forgot-email"
              type="email"
              required
              autoFocus
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-2 h-12 rounded-xl border-[var(--mp-ink)]"
              placeholder="tua@email.it"
            />
          </div>
          <Button
            type="submit"
            disabled={loading}
            data-testid="forgot-submit"
            className="w-full h-12 rounded-full bg-[var(--mp-ink)] hover:bg-black text-white"
          >
            {loading ? "Invio…" : "Invia link di reset"}
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
